// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-todo-summary',
    // #endregion
    // #region Constructor
    props: {
        schema: {
            type: Object,
            required: false,
            default: undefined,
        },
        schemaData: {
            type: Object,
            required: false,
            default: undefined,
        },
        content: {
            type: Object,
            required: false,
            default: undefined,
        },
        data: {
            type: Object,
            required: false,
            default: undefined,
        },
    },
    // #endregion      
});
// #endregion
